// smartyUtils.js
export const getViewType = (pathname, viewProp) => {
  if (viewProp) return viewProp;
  if (pathname.includes('/today')) return 'today';
  if (pathname.includes('/month')) return 'month';
  if (pathname.includes('/expired')) return 'expired';
  if (pathname.includes('/expiring')) return 'expiring';
  if (pathname.includes('/location')) return 'location';
  if (pathname.includes('/by-storage')) return 'location';
  if (pathname.includes('/condition')) return 'condition';
  if (pathname.includes('/categories')) return 'categories';
  if (pathname.includes('/byfamily')) return 'byfamily';
  if (pathname.includes('/predictive')) return 'predictive';
  if (pathname.includes('/waste-analysis')) return 'waste-analysis';
  if (pathname.includes('/savings')) return 'savings';
  if (pathname.includes('/inventory')) return 'inventory';
  if (pathname.includes('/consumed')) return 'consumed';
  if (pathname.includes('/wasted')) return 'wasted';
  if (pathname.includes('/given')) return 'given';
  return 'all'; // default
};
